import { observer } from 'mobx-react-lite'
import { Checkbox, Icon, Tooltip, Typography } from 'shared/ui'
import { ENROLL_BY_WEBHOOK_TOOLTIP } from 'widgets/EnrollByWebhook/text.ts'
import { type EnrollByWebhookStore } from 'widgets/EnrollByWebhook/store/EnrollByWebhookStore.ts'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import styles from './styles.module.scss'

type ITriggerStep1Props = {
  runAutomatically: boolean
  onSelect: (index: number) => void
  enrollByWebhookStore: EnrollByWebhookStore
  focusedIndex: number
}

export const TriggerStep1 = observer(
  ({ runAutomatically, onSelect, enrollByWebhookStore, focusedIndex }: ITriggerStep1Props) => {
    return (
      <div className={styles.list}>
        <WidgetItem
          leftNode={<Checkbox checked disabled ariaLabel={'ManuallyCheckbox'} size={20} />}
          rightNode={
            <Tooltip
              label='Start this agent manually from:'
              desc={
                <>
                  Conversations
                  <br />
                  Contacts
                  <br />
                  Broadcasts
                  <br />
                  Workflows
                </>
              }
              type='description'
              placement={'top'}
              breakWord
            >
              <Icon icon={'question'} color={'var(--content-neutral-primary)'} />
            </Tooltip>
          }
        >
          <Typography variant={'body-rg-regular'} ariaLabel={'ManuallyLabel'}>
            Manually
          </Typography>
        </WidgetItem>
        <WidgetItem
          isFocused={focusedIndex === 1}
          onClick={() => onSelect(1)}
          leftNode={
            <Checkbox checked={runAutomatically} ariaLabel={'AutomaticallyCheckbox'} size={20} />
          }
          rightNode={
            <Tooltip
              label='The agent runs automatically when contacts match the enrollment criteria'
              placement={'top'}
              breakWord
            >
              <Icon icon={'question'} color={'var(--content-neutral-primary)'} />
            </Tooltip>
          }
        >
          <Typography variant={'body-rg-regular'} ariaLabel={'AutomaticallyLabel'}>
            Automatically
          </Typography>
        </WidgetItem>
        <WidgetItem
          isFocused={focusedIndex === 2}
          onClick={() => onSelect(2)}
          leftNode={
            <Checkbox
              checked={enrollByWebhookStore.isActive}
              ariaLabel={'ByWebhookCheckbox'}
              size={20}
            />
          }
          rightNode={
            <Tooltip label={ENROLL_BY_WEBHOOK_TOOLTIP} placement={'top'} breakWord>
              <Icon icon={'question'} color={'var(--content-neutral-primary)'} />
            </Tooltip>
          }
        >
          <Typography variant={'body-rg-regular'} ariaLabel={'ByWebhook'}>
            By webhook
          </Typography>
        </WidgetItem>
      </div>
    )
  }
)
